import { render, staticRenderFns } from "./SelectHospital.vue?vue&type=template&id=1cd27f50&scoped=true&"
import script from "./SelectHospital.vue?vue&type=script&lang=ts&"
export * from "./SelectHospital.vue?vue&type=script&lang=ts&"
import style0 from "./SelectHospital.vue?vue&type=style&index=0&id=1cd27f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd27f50",
  null
  
)

export default component.exports